module.exports = __webpack_public_path__ + "static/thomann-7e47bfff629f7ed907e9ef01b64b6446.png";